export const USE_CIT = {
  AUTO: 'AUTO',
  YES: true,
  NO: false,
};

export const TILE_TYPES = {
  RASTER: 'raster',
  VECTOR: 'vector',
  VECTORHARP: 'vectorHARP',
  RASTERV3: 'rasterv3',
};

export const ADVANCED_ROADS = 'default,advanced_roads';

export const TILE_LIBRARY_TYPES = {
  LEAFLET: 'leaflet',
  JSLA: 'jsla',
};

export const TILE_URLS = [
  'vector.hereapi.com',
  'origin.vector.hereapi.com',
  'vector.sit.hereapi.com',
  'origin.vector.sit.hereapi.com',
];

// South Korea (region 'KR') regional endpoints. KR map data is GeoIP-restricted
// and must be served from the heremaps.kr hosts instead of the worldwide hosts.
export const TILE_URL_KOREAN_PRD = 'vector.heremaps.kr';
export const TRAFFIC_OVERLAY_URL_KOREAN_PRD = 'traffic.vector.heremaps.kr';

export const TILE_PATHS = [
  '/v2/vectortiles/core/mc/'   // rest vectors
];

export const TRAFFIC_OVERLAY_URLS = [
  'traffic.vector.hereapi.com'
];

export const TILE_STYLE_URLS = [
  'https://js.api.here.com/v3/3.1/styles/omv/miami/normal.day.yaml',
  'https://js.api.here.com/v3/3.1/styles/omv/oslo/japan/normal.day.yaml',
];

export const TILE_STYLE_HARP_URLS = [
  'https://js.api.here.com/v3/3.1/styles/harp/oslo/normal.day.json',
  'https://js.api.here.com/v3/3.1/styles/harp/oslo/tko.normal.day.json',
];
